import React from "react";
import {
  RvCommunityVisibility,
  RvCommunityNetworking,
  RvCommunityMentorship,
  RvcommunityEvents,
  RvCommunityAccelerator,
  RvComminityLegal,
} from "../../../../app-constants-updated";
import { Col, Container, Row } from "react-bootstrap";

function Communitybenefits() {
  return (
    <section className="community_benefits p-100 text_white">
      <Container>
        <div className="benefits-main">
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="text-center"
            >
              <span style={{ color: "#f47a14" }}>Benefits</span>
              <h2>What is in it for you!</h2>
            </Col>
          </Row>
          <Row className="mt-3 mt-md-4">
            <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
              <div className="comminity-benefits-main">
                <div className="community-benefits-item">
                  <div className="num">
                    <span>01</span>
                  </div>
                  <div className="comminity-benefits-icon">
                    {RvCommunityVisibility}
                  </div>
                  <div className="community-content">
                    <h5>Advanced Visibility</h5>
                    <p>
                      A global recognition is not easy to earn but with 100K+
                      members, you will have the spotlight that your business
                      deserves.
                    </p>
                  </div>
                </div>
                <div className="community-benefits-item">
                  <div className="num">
                    <span>02</span>
                  </div>
                  <div className="comminity-benefits-icon">
                    {RvCommunityNetworking}
                  </div>
                  <div className="community-content">
                    <h5>Better Networking</h5>
                    <p>
                      With industry leaders from across the globe, you will be
                      in the company of leaders to shape your way to success.
                    </p>
                  </div>
                </div>
                <div className="community-benefits-item">
                  <div className="num">
                    <span>03</span>
                  </div>
                  <div className="comminity-benefits-icon">
                    {RvCommunityMentorship}
                  </div>
                  <div className="community-content">
                    <h5>Mentorship</h5>
                    <p>
                      Worried about getting stuck, getting expert advice and
                      mentorship from leaders of 15+ industries.
                    </p>
                  </div>
                </div>
                <div className="community-benefits-item">
                  <div className="num">
                    <span>04</span>
                  </div>
                  <div className="comminity-benefits-icon">
                    {RvcommunityEvents}
                  </div>
                  <div className="community-content">
                    <h5>Exclusive Events</h5>
                    <p>
                      We host events in different parts of the world to help
                      entrepreneurs connect with each other to better network
                      and compete in hackathons.
                    </p>
                  </div>
                </div>
                <div className="community-benefits-item">
                  <div className="num">
                    <span>05</span>
                  </div>
                  <div className="comminity-benefits-icon">
                    {RvCommunityAccelerator}
                  </div>
                  <div className="community-content">
                    <h5>Accelerator Program</h5>
                    <p>
                      Being a part of the community means you are always
                      eligible to accelerate your business with our accelerator
                      program.
                    </p>
                  </div>
                </div>
                <div className="community-benefits-item">
                  <div className="num">
                    <span>06</span>
                  </div>
                  <div className="comminity-benefits-icon">
                    {RvComminityLegal}
                  </div>
                  <div className="community-content">
                    <h5>Legal Guidance</h5>
                    <p>
                      Streamline your journey as we handle the cumbersome
                      paperwork, allowing you to focus on understanding the
                      dynamics of bringing your company to life.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Communitybenefits;
